import { AxiosInstance, AxiosResponse } from 'axios'

export interface ApiKey {
  id: string
  keyName: string
  apiKeyPrefix: string
  createdDate: string
}

export interface ApiKeyCreatePayload {
  keyName: string
}

export interface ApiKeyCreateResponse extends ApiKey {
  apiKey: string
}

export default class ApiKeyApi {
  constructor(private client: AxiosInstance) {}

  getAllAPIKeys = (): Promise<AxiosResponse<ApiKey[]>> => this.client.get('/apiKeys')

  createNewAPI = (body: ApiKeyCreatePayload): Promise<AxiosResponse<ApiKeyCreateResponse>> => this.client.post(`/apiKeys`, body)

  updateAPI = (id: string, body: ApiKeyCreatePayload): Promise<AxiosResponse<ApiKey>> => this.client.put(`/apiKeys/${id}`, body)

  deleteAPI = (id: string): Promise<AxiosResponse<any>> => this.client.delete(`/apiKeys/${id}`)
}
